import React from "react";
import styled from "styled-components";
import { graphql, useStaticQuery } from "gatsby";
import { BodySemibold } from "storybook-components/Typography";
import BlogLogoLink from "../BlogNav/BlogLogoLink";
import ContentCard from "./ContentCard";
import CtaCard from "./CtaCard";

const SideBar = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  z-index: 99;
  top: 0;
  right: 0;
  ${props => props.theme.media.tabletUp`
    flex-direction: column;
    height: 100%;
    max-width: 280px;
  `};
`;

const InnerWrapper = styled.div`
  display: block;
  ${props => props.theme.media.tabletUp`
    position: sticky;
    flex-direction: column;
    top: 100px;
    max-width: 280px;
`};
`;

const LogoWrapper = styled.div`
  display: none;
  ${props => props.theme.media.desktopUp`
    display: block;
    margin-left: 60px;
  `};
`;

const Heading = styled(BodySemibold)`
  margin-top: 40px;
  font-size: 1.5rem;
  ${props => props.theme.media.desktopUp`
    font-size: 1.125rem;
    margin-left: 60px;
  `};
`;

const RelatedContentSidebar = () => {
  const data = useStaticQuery(graphql`
    query SidebarQuery {
      sidebar: allContentfulRelatedContentSidebar {
        nodes {
          contentCards {
            contentLinkUrl
            contentType
            title
            contentImage {
              gatsbyImageData
            }
          }
        }
      }
    }
  `);
  const sideBar = data?.sidebar?.nodes;
  const cards = sideBar?.length ? sideBar[0].contentCards : [];
  return (
    <SideBar>
      <InnerWrapper>
        <LogoWrapper>
          <BlogLogoLink />
        </LogoWrapper>
        <Heading>Additional Resources</Heading>
        {cards.map(card => (
          <ContentCard
            title={card.title}
            contentType={card.contentType}
            contentImage={card.contentImage}
            contentLinkUrl={card.contentLinkUrl}
          />
        ))}
        <CtaCard/>
      </InnerWrapper>
    </SideBar>
  );
};

export default RelatedContentSidebar;
